import React from 'react';
import { Box } from '@mui/material';
import { marketingColors as C, marketingFonts as F, visualTokens as V } from '../../theme_landing_page_2';

interface EyebrowProps {
  children: React.ReactNode;
  /** Use on dark or photo backgrounds for readable contrast. */
  variant?: 'light' | 'onImage';
}

/** The small uppercase pill label ("Features", "Pricing", "Compare") used above every section headline. */
const Eyebrow: React.FC<EyebrowProps> = ({ children, variant = 'light' }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      background: variant === 'onImage' ? V.paperAlpha18 : C.panel,
      border: `1px solid ${variant === 'onImage' ? V.paperAlpha34 : C.hairline}`,
      borderRadius: V.borderRadius32px,
      padding: 'calc(8px * var(--website-eyebrow-scale, 1)) calc(14px * var(--website-eyebrow-scale, 1))',
      fontFamily: F.wordmark,
      fontSize: `calc(${V.fontSize12} * var(--website-eyebrow-scale, 1))`,
      fontWeight: V.fontWeight600,
      letterSpacing: V.letterSpacing0_14em,
      textTransform: 'uppercase',
      lineHeight: 1,
      color: variant === 'onImage' ? V.onDark : V.brandBlue,
    }}
  >
    {children}
  </Box>
);

export default Eyebrow;
